import { useQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
import useErrorHandler from '../../../gqlCommon/hooks/useErrorHandler';
import customizeCarModel from '../../graphql/queries/customizeCarModel';
import {
  GetCustomizeCarModel,
  GetCustomizeCarModel_customizeCar,
  GetCustomizeCarModelVariables,
} from '../../graphql/queries/__generated__/GetCustomizeCarModel';
import useCustomizeCarContext from '../useCustomizeCarContext';

export const useFetchCurrentCarModel = () => {
  const { selectedCar } = useCustomizeCarContext();
  const carId = selectedCar?.car?.code;

  const { data, loading, error } = useQuery<GetCustomizeCarModel, GetCustomizeCarModelVariables>(
    customizeCarModel.GET_CUSTOMIZE_CAR_MODEL,
    {
      variables: {
        carId,
      },
      skip: !carId,
    },
  );
  const [selectedCarModelData, setSelectedCarModelData] = useState<GetCustomizeCarModel_customizeCar | null>(null);

  useEffect(() => {
    if (!loading && data) {
      setSelectedCarModelData(data?.customizeCar);
    }
  }, [loading, data]);

  useErrorHandler(error);

  return { data, selectedCarModelData, loading, error };
};
